import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

const useExploreTabs = () => {
  const { tab } = useParams()
  const navigate = useNavigate()
  const handleChange = (value: string) => {
    navigate(`/home/${value}`)
  }
  useEffect(() => {
    document.title = `Explore ${tab}`
  }, [tab])
  return { tab, handleChange }
}

export default useExploreTabs
